import React from 'react';
import { ProductLineTitle } from '@insurancemenu/imenu-components-lib/dist/components';
import { ProductLineId, OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductSelectStyled, DetailsButtonStyled } from './styles';
import { SUB_PRODUCT_DETAILS_BUTTON_TEST_ID, SUB_PRODUCT_SELECT_TEST_ID } from '../../../../constants';

interface Props {
  productLineId: ProductLineId;
  productId: string;
  subscriberId: string;
  planOptions: OptionType[];
  isEditable?: boolean;
  onShowDetails?: (productLineId: ProductLineId) => void;
  onProductChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ProductSelect: React.FC<Props> = ({
  subscriberId,
  productLineId,
  productId,
  planOptions,
  isEditable = false,
  onShowDetails,
  onProductChange,
}) => {
  const onShowCardDetails = (): void => {
    onShowDetails?.(productLineId);
  };

  return (
    <ProductSelectStyled
      $isDisabled={!isEditable}
      id={`product-select-${subscriberId}-${productLineId}`}
      name={`product-select-${subscriberId}-${productLineId}`}
      value={productId}
      label={<ProductLineTitle productLineId={productLineId} />}
      width="100%"
      options={planOptions}
      disabled={!isEditable}
      placeholder="--Make election--"
      description={
        onShowDetails ? (
          <DetailsButtonStyled
            type="text"
            uppercase
            color="primary"
            onClick={onShowCardDetails}
            data-test-id={SUB_PRODUCT_DETAILS_BUTTON_TEST_ID}
          >
            Details
          </DetailsButtonStyled>
        ) : null
      }
      onChange={onProductChange}
      data-test-id={SUB_PRODUCT_SELECT_TEST_ID}
    />
  );
};

export default ProductSelect;
